module.exports = __webpack_public_path__ + "static/media/02.d5bfb149.mp3";